import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  iscancel? :boolean ;
  dialogTitle: string;
  dialogText: string;
  dialogActions: string;
  dialogPrecision: string;
  dialogButtonConfirm: string;
  dialogButtonCancel: string;
  codeType?: string;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
